// extracted by mini-css-extract-plugin
export default {"announcements-list-modal":"styles_announcements-list-modal__uoHd7","announcements-list-modal__body":"styles_announcements-list-modal__body__O512r"};